
<template>
  <!--单元管理-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="unitId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      @resetSearch = 'resetHandle'
    >
    </x-tabula>
  </div>
</template>

<script>
import {fetchSelect} from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'unit',
  data () {
    return {
      cascadeParam: {},
      searchList: [
        { label: '', props: [`${this.$route.name}/communityId`], placeholder: '小区', options: [], inputType: 'select', handle: ($event) => this.communityChange(5, $event), fetchOptions: this.getOptions},
        { label: '', props: ['keywords'], placeholder: '名称、编码', options: [], inputType: 'input' },
        { label: '', props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        {
          label: '',
          props: ['areas'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(3, 'searchList', '1,2,3', e);
          }
        },
        { label: '', props: ['propertyId'], placeholder: '物业公司', options: [], inputType: 'select' },
        { label: '', props: [`${this.$route.name}/buildingId`], placeholder: '楼栋', options: [], inputType: 'select' },
        { label: '', props: ['standardAddress'], placeholder: '标准地址查询', options: [], inputType: 'input' }
      ],
      searchParams: {
        [`${this.$route.name}/communityId`]: undefined,
        keywords: undefined,
        createDate: undefined,
        areas: undefined,
        propertyId: undefined,
        [`${this.$route.name}/buildingId`]: undefined,
        standardAddress: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:units:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:units:remove'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:units:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:units:remove'] }
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '所属楼栋', dataIndex: 'building', align: 'left', width: '' },
        { title: '名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '编号', dataIndex: 'unitNo', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/units/list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addUnit',
        addTitle: '新增单元',
        editTitle: '修改单元'
      },
      deleteParam: {
        url: '/units/',
        title: '单元',
        key: 'title'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    resetHandle () {
      this.searchList[5].options = [];
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(3);
      this.propertySelect(4);
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
    },
    resHandle (res) {
      res.forEach((el) => {
        el.building = `${el.communityName} ${el.buildingName}`;
      });
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
